<template>
  <BContainer
    class="mb-4 px-0"
  >
    <BModal
      ref="modalAreaClusters"
      size="lg"
      centered
      scrollable
      no-close-on-esc
      no-enforce-focus
      no-close-on-backdrop
      modal-class="full-height modal-no-padding"
      aria-hidden="false"
      role="dialog"
      title="Area Clusters"
    >
      <div
        class="px-2"
        style="min-height: calc(100vh - 200px);"
      >
        <BRow
          class="pb-2"
        >

          <BCol
            cols="12"
            md="6"
          >
            <BFormGroup
              label="Team"
              label-for="fTeam"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fTeam"
                v-model="area.team.team_name"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="6"
          >
            <BFormGroup
              label="Area"
              label-for="fArae"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fArea"
                v-model="area.area_name"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="6"
          >
            <ValidationObserver
              ref="formAreaCluster"
            >
              <form
                role="form"
                novalidate
                @submit.prevent
              >
                <ValidationProvider
                  v-slot="{ errors }"
                  vid="cluster_id"
                  name="cluster"
                  rules="required"
                >
                  <BFormGroup
                    label="Cluster"
                    label-for="fCluster"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <VSelect
                      v-model="selected.cluster"
                      input-id="fCluster"
                      label="cluster_name"
                      append-to-body
                      placeholder="select cluster here"
                      :options="filteredClusters"
                      :disabled="fetching.clusters"
                      :loading="fetching.clusters"
                      :class="{ 'is-invalid': errors.length > 0 }"
                    >
                      <template #selected-option="{ cluster_name }">
                        <div
                          class="w-225px w-lg-325px text-truncate"
                          v-text="cluster_name"
                        />
                      </template>
                      <template #no-options="">
                        no available cluster
                      </template>
                    </VSelect>
                    <div
                      v-if="(errors.length > 0)"
                      class="invalid-feedback"
                      v-text="errors[0]"
                    />
                  </BFormGroup>
                </ValidationProvider>
              </form>
            </ValidationObserver>
          </BCol>

          <BCol>
            <BFormGroup
              class="mb-2"
            >
              <label
                for="actionButtons"
                class="d-none d-md-block"
              >
                &nbsp;
              </label>
              <BButton
                variant="primary"
                :disabled="state.busy || !selected.cluster"
                @click="validateCluster"
              >
                Add Cluster
              </BButton>
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
          >
            <BFormGroup
              label="Search"
              label-for="filterClusterSearch"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="filterClusterSearch"
                v-model="tableAreaClusters.filter.search"
                placeholder="search here"
                autocomplete="off"
                debounce="1000"
                type="text"
              />
            </BFormGroup>
          </BCol>
        </BRow>

        <CustomTable
          ref="tableAreaClusters"
          :provider="tableProvider"
          :fields="tableAreaClusters.fields"
          :filter="tableAreaClusters.filter"
          :filter-on="tableAreaClusters.filterOn"
          :sort-by="tableAreaClusters.sortBy"
          :sort-desc="tableAreaClusters.sortDesc"
          :sort-direction="tableAreaClusters.sortDirection"
          :total-rows="tableAreaClusters.totalRows"
          :current-page="tableAreaClusters.currentPage"
          :per-page="tableAreaClusters.perPage"
          :stacked="tableAreaClusters.stacked"
          :busy="tableAreaClusters.busy"
        >
          <template #cell(index)="{ index }">
            {{ index + 1 }}
          </template>
          <template #cell(action)="{ item }">
            <div class="text-md-nowrap d-flex flex-column flex-md-row justify-content-center gap-2">
              <BButton
                size="sm"
                variant="danger"
                @click.prevent="updateActive(item)"
              >
                {{ Number(item.active) === 1 ? 'Deactivate' : 'Activate' }}
              </BButton>
            </div>
          </template>
        </CustomTable>
      </div>

      <template #modal-footer="{ cancel }">
        <BButton
          variant="outline-dark"
          :disabled="state.busy"
          @click.prevent="discardBtnEvent => preventAriaHidden(discardBtnEvent, cancel)"
        >
          Close
        </BButton>
      </template>
    </BModal>
  </BContainer>
</template>

<script>
import { find } from 'lodash'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'
import MClusters from '@/mixins/locations/clusters'

import { SAdminAreaCluster } from '@/services/admin'

// import QUERY from 'lodash'

export default {
  name: 'VAdminUserLocationsAreaClusters',

  mixins: [
    MxMisc,
    MxFormatter,
    MClusters
  ],

  middleware: [
    'auth',
    'admin'
  ],

  emits: ['updated'],

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      selected: {
        area: ''
      },
      area: {
        id: '',
        area_code: '',
        area_name: '',
        team_id: '',
        team: {
          id: '',
          team_name: ''
        }
      },
      formAreaCluster: {
        id: '',
        area_id: '',
        cluster_id: ''
      },
      tableAreaClusters: {
        busy: false,
        filter: {
          search: ''
        },
        filterOn: [],
        stacked: 'sm',
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        rows: [],
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 4, key: 'action', class: 'text-center w-md-125px' },
          { mobile: 2, key: 'created_at', class: 'text-center w-md-125px', formatter: this.dateTimeShortFormatter },
          { mobile: 1, key: 'cluster_name', label: 'Cluster', class: 'min-w-175px' },
          { mobile: 3, key: 'updated_at', class: 'text-center w-md-125px', formatter: this.dateTimeShortFormatter }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  computed: {
    filteredClusters () {
      return this.options.clusters.filter(
        ({ id }) => !Array.from(this.tableAreaClusters.rows).some(
          areaCluster => String(areaCluster.id) === String(id)
        )
      )
    }
  },

  watch: {
    'selected.cluster' (cluster) {
      this.formAreaCluster.cluster_id = cluster?.id || ''
    }
  },

  methods: {
    async tableProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      this.tableAreaClusters.busy = true

      const payload = {
        page: currentPage,
        per_page: perPage,
        sort: sortBy,
        sort_desc: sortDesc,
        area_id: this.area.id,
        filter_text: filter.search
      }

      return SAdminAreaCluster.get(payload).then(
        ({ data }) => {
          this.tableAreaClusters.totalRows = data.total_rows
          this.tableAreaClusters.rows = data.items

          return data.items
        }
      ).catch(() => {
        this.tableAreaClusters.totalRows = 0
        return []
      }).finally(() => {
        this.tableAreaClusters.busy = false
      })
    },

    manageAreaClusters (area) {
      this.area = Object.assign(this.area, {
        id: area.id,
        area_code: area.area_code,
        area_name: area.area_name,
        team_id: area.team_id,
        team: Object.assign(this.area.team, {
          id: area.team?.id || '',
          team_name: area.team?.team_name || ''
        })
      })

      this.selected.area = find(this.options.areas, { id: area.id }) || ''

      this.formAreaCluster = Object.assign(this.formAreaCluster, {
        id: '',
        area_id: area.id,
        cluster_id: ''
      })

      this.getClusters(this, '', area?.id)

      this.$refs.modalAreaClusters.show()
    },

    validateCluster () {
      return this.$refs.formAreaCluster.validate().then(
        validCluster => {
          if (!validCluster) {
            return this.swalInvalid()
          }

          return this.swalConfirm({
            html: '<h6>Add Cluster to this Area?</h6>',
            confirmButtonText: 'Add',
            preConfirm: async () => {
              this.state.busy = true

              return SAdminAreaCluster.post(this.formAreaCluster).then(
                ({ data: { message } }) => {
                  this.swalSuccess(message).then(() => {
                    this.$refs.tableAreaClusters.refetch()
                  })
                }
              ).finally(() => {
                this.state.busy = false
              })
            }
          })
        }
      )
    },

    updateActive (item) {
      const isActive = Number(item.active) === 1

      return this.swalConfirm({
        html: `${isActive ? 'Deactivate' : 'Activate'} this Area Cluster?`,
        confirmButtonText: isActive ? 'Deactivate' : 'Activate',
        customClass: {
          confirmButton: isActive ? 'btn btn-sm btn-danger' : 'btn btn-sm btn-success'
        },
        preConfirm: async () => {
          this.state.busy = true

          return SAdminAreaCluster.post({
            id: item.id,
            active: isActive ? 0 : 1
          }).then(
            ({ data: { message } }) => {
              this.swalSuccess(message).then(() => {
                this.$refs.tableAreaClusters.refetch()
              })
            }
          ).finally(() => {
            this.state.busy = false
          })
        }
      })
    }
  }
}
</script>
